import React from "react";
import LandMain from "../components/LandMain.tsx";
import styles from "../styles/Landing.module.css";

const Landing = () => {
	return (
		<div className={styles.landing}>
			<LandMain />
		</div>
	)
}

export default Landing;